module.exports = __webpack_public_path__ + "img/32.1e853671.jpg";